<ngx-zero-state class="full-screen course-zero-state">
	@if (course.isPast()) {
		<section zero-state-body class="expired-course-section">
			<img class="zero-state-hmmm-image"
				src="https://staticassets.goreact.com/zero-state-lady-hmm-01.png"
				alt="{{'course-payment-wall_expired-zero-state-hmmm-image-alt' | translate}}">

			<div class="course-name">
				{{course.name}}
			</div>

			<p [innerHTML]="'course-payment-wall_paid-course-expired' | translate: { expiredAt: course.end_date | date: 'mediumDate' }"></p>

			<button
				type="button"
				class="primary-btn unregister-btn"
				[attr.aria-label]="('course-payment-wall_unregister_aria_label' | translate: {course: course.name})"
				(click)="openUnregisterModal()"
				translate="course-payment-wall_unregister">
			</button>
		</section>
	} @else {
		<section zero-state-title>
			<p class="title regular" translate="course-payment-wall_title"></p>
			<p class="title mobile" translate="course-payment-wall_title-mobile"></p>
		</section>
	}

	@if (!course.isPast() && user.plan?.has_plan) {
		<section zero-state-body class="expiring-plan-section">
			<p>{{ 'course-payment-wall_paid-course-plan-expiring' | translate: {expirationDate: user.plan.ends_at | date: 'mediumDate', folderName: course.name} }}</p>

			<div class="button-container">
				<button
					type="button"
					class="btn secondary-btn pay-btn card"
					(click)="onPay.emit({type: 'CARD'})"
					analytics-on="click"
					analytics-event="pay-with-card"
					analytics-category="pay-wall"
					data-cy="pay-with-card"
					translate="course-payment-wall_pay-with-card">
				</button>
				<button
					type="button"
					class="btn secondary-btn pay-btn credits"
					[attr.aria-label]="('course-payment-wall_pay-credit-aria-label' | translate: {course: course.name})"
					(click)="onCredit.emit()"
					translate="course-payment-wall_use-existing-plan">
				</button>
				<button
					type="button"
					class="btn primary-btn pay-btn code"
					analytics-on="click"
					analytics-event="enter-code"
					analytics-category="pay-wall"
					[attr.aria-label]="('course-payment-wall_pay-card-code-aria-label' | translate: {course: course.name})"
					(click)="onPay.emit({type: 'CODE'})"
					translate="course-payment-wall_enter-code">
				</button>
			</div>

			<div class="bottom-links">
				@if (!isLtiEnvironment) {
					<button
						type="button"
						class="link-btn drop-course-btn"
						(click)="openDropUserModal()"
						analytics-on="click"
						analytics-event="switching-from-course"
						analytics-category="pay-wall"
						wcag-ignore>
						<span translate="course-payment-wall_drop"></span>
					</button>
				}

			</div>

			<div zero-state-graphic-bottom>
				<img class="zero-state-image" [src]="activeBrandService.getImage('floating-astronaut.svg')" alt="not found">
			</div>
		</section>
	}

	@if (!course.isPast() && !user.plan?.has_plan) {
		<section zero-state-body>
			<p>{{ 'course-payment-wall_paid-course' | translate: {folderName: course.name} }}</p>

			@if (user.totalStudentCredits) {
				<p>
					@switch (user.totalStudentCredits) {
						@case (1) {
							<span>{{ 'course-payment-wall_currently-have-singular' | translate: {numCredits: user.totalStudentCredits} }}</span>
						}
						@default {
							<span>{{ 'course-payment-wall_currently-have-plural' | translate: {numCredits: user.totalStudentCredits} }}</span>
						}
					}
				</p>
			}

			@if ((paymentTransactionState$ | async); as paymentTransactionState) {
				@if (paymentTransactionState === paymentTransactionStatus.DONE) {
					<div>
						<div class="button-container">
							<button
								type="button"
								class="btn pay-btn card"
								[ngClass]="user.totalStudentCredits ? 'secondary-btn' : 'primary-btn'"
								[attr.aria-label]="('course-payment-wall_pay-card-code-aria-label' | translate: {course: course.name})"
								(click)="onPay.emit({type: 'CARD'})"
								analytics-on="click"
								analytics-event="pay-with-card"
								analytics-category="pay-wall"
								data-cy="pay-with-card"
								translate="course-payment-wall_pay-with-card">
							</button>

							<button
								type="button"
								class="btn pay-btn code"
								[ngClass]="user.totalStudentCredits ? 'secondary-btn' : 'primary-btn'"
								analytics-on="click"
								analytics-event="enter-code"
								analytics-category="pay-wall"
								[attr.aria-label]="('course-payment-wall_pay-card-code-aria-label' | translate: {course: course.name})"
								(click)="onPay.emit({type: 'CODE'})"
								translate="course-payment-wall_enter-code">
							</button>

							@if (user.totalStudentCredits) {
								<button
									type="button"
									class="btn primary-btn pay-btn credits"
									[attr.aria-label]="('course-payment-wall_pay-credit-aria-label' | translate: {course: course.name})"
									(click)="onCredit.emit()"
									translate="course-payment-wall_use-course-credit">
								</button>
							}
						</div>

						<div class="bottom-links">
							@if (!isLtiEnvironment) {
								<button
									type="button"
									class="link-btn drop-course-btn"
									(click)="openDropUserModal()"
									analytics-on="click"
									analytics-event="switching-from-course"
									analytics-category="pay-wall">
									<span translate="course-payment-wall_drop"></span>
								</button>
							}
						</div>

						<div zero-state-graphic-bottom>
							<img class="zero-state-image" [src]="activeBrandService.getImage('floating-astronaut.svg')" alt="not found">
						</div>
					</div>
				}

				@if (paymentTransactionState === paymentTransactionStatus.PENDING) {
					<p translate="payment-pending-transaction" class="alert alert-info pending-transaction"></p>
				}

				@if (paymentTransactionState === paymentTransactionStatus.LOADING) {
					<span>
						<i class="ficon-spinner ficon-spin"></i>
					</span>
				}
			}
		</section>
	}
</ngx-zero-state>
